// extracted by mini-css-extract-plugin
export default {"title":"b628c00f59","bld":"cc23ea866b"};